import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getDevData } from "../../services/generalService";
import { ChargeReversalObj } from "../../utils/types";

const initialState: ChargeReversalObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getChargeReversalDetails = createAsyncThunk(
  "loans/getChargeReversalDetails",
  async (url: string, thunkAPI) => {
    try {
      const data = await getDevData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

const chargeReversalGetSlice = createSlice({
  name: "chargesReversal",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getChargeReversalDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getChargeReversalDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getChargeReversalDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default chargeReversalGetSlice.reducer;
